<template>
  <div class="product-tab" @click="$emit('openProduct',name)">
    <img class="tab-icon" :src="tabIcon" alt="">
    <div class="title-container">
      <h5>Amnium</h5>
      <h5 class="sub-title" :class="textColor">{{ subTitle }}</h5>


    </div>
    <h5 class="mainInfo">{{ mainInfo }}</h5>
    <h6 class="subInfo"> {{ subInfo }}</h6>
  </div>
</template>

<script>

export default {
  name: 'ProductTab',
  props: {
    subTitle: String,
    tabIcon: String,
    mainInfo: String,
    subInfo: String,
    name: String,
    textColor: {
      type: String,
      default: 'yellow'
    }
  }
}

</script>

<style lang="scss">
@import "ProductTab.scss";
</style>
